import axio from '../js/axio'
 
//export const HTTPS = 'https://localhost:44398' // 本机
//export const HTTPS = 'http://114.116.96.37:6604' // 本地测试
// export const HTTPS = 'https://alljapan.jhss-jp.com' // 本地正式
 export const HTTPS = '' // 正式发布

// 获取客户列表
export const getCustomer = data => axio('/api/SysUser/GetAllDataUser2', data)

// 条形码地址
export const imgSrc = data => { return HTTPS + '/uploadfiles/' + data }

// 物流图片地址
export const imgSrc2 = data => { return HTTPS + '/uploadfiles2/' + data }

// 集装箱信息
export const getContainerInfo = data => axio('/api/WlJzxhistory/GetDtByCityAndDate', data)

// 查询指定日期集装箱订单信息
export const getContainerOrder = data => axio('/api/WlJzxhistory/GetAll', data)

// 查看附件
export const checkAttachment = data => axio('/api/WlJzxhistory/GetAllFile', data)

// 查询当天集装箱关西签收单
export const getOneDayKansaiReceipt = data => axio('/api/WlJzxhistory/GetAllQSD2', data)

// 查询当天集装箱关东签收单
export const getOneDayKantoReceipt = data => axio('/api/WlJzxhistory/GetAllGdQSD2', data)

// 集装箱签收单，下载单个文件
export const loadOneFile = data => axio('/api/WlJzxhistory/SetDownLog', data)

// 集装箱签收单，下载多个文件
export const loadMultipleFiles = data => axio('/api/WlJzxhistory/SetDownZipLog', data)

// 查询上传集装箱关西签收单
export const getKansaiReceipt = data => axio('/api/WlJzxhistory/GetAllQSD', data)

// 查询上传集装箱关东签收单
export const getKantoReceipt = data => axio('/api/WlJzxhistory/GetAllGdQSD', data)

// 查询上传集装箱回传签收单
export const getReturnReceipt = data => axio('/api/WlJzxhistory/GetAllHCD', data)

// 查询上传集装箱账单
export const getBillFiles = data => axio('/api/WlJzxhistory/GetAllZdFile', data)

// 查询上传集装箱异常情况附件
export const getAbnormalAttachment = data => axio('/api/WlJzxhistory/GetAllYC', data)

// 查询集装箱订单信息
export const queryContainerOrder = data => axio('/api/WlJzxhistory/GetAll', data)

// 根据集装箱编号查物流询订单信息
export const containerGetOrder = data => axio('/api/WlJzxhistory/GetOrderByJzxnum', data)

// 集装箱订单---标签上传、删除、一条订单的标签文件查询
export const getTallyFile = data => axio('/api/WlJzxhistory/GetAllBiaoQian', data)

// 集装箱订单---当天的标签文件查询
export const getDayTallyFile = data => axio('/api/WlJzxhistory/GetAllBiaoQian2', data)

// 获取SKU文件
export const getSKUTallyFile = data => axio('/api/WlJzxhistory/GetBiaoQianDt', data)

export const getQrCode = data => axio('/api/WlJzxhistory/GetQrCode', data)

export const BianQianQrPage = data => {return HTTPS+'/pdf/BianQianQrPage?JZXID='+data}

//下载文件导出
export const DownloadFile = data => {return HTTPS+'/xlsx/'+data}

// 获取亚马逊订单信息
export const getAmazonOrder = data => axio('/api/WlAmazonhistory/GetAmazon', data)

// 查询状态说明
export const checkOrderStatus = data => axio('/api/WlAmazonhistory/GetStateByPid', data)

// 查询物流信息
export const checkOrderLogistics = data => axio('/api/WlAmazonhistory/GetWlByPid', data)